import React from "react"
import { Outlet } from "react-router-dom"
import "../../styles/Layouts/loginlayout.css"

const LoginLayout = ({ children }) => {
  return (
    <div className="login-bg-img">
      <div className="d-flex justify-content-center align-items-center h-100 w-100">
        <div className="login-container">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default LoginLayout
